export const spacing = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48];
